import { LoadingButton } from '@mui/lab';
import { Alert, Link, Stack, Typography } from '@mui/material';
import { ChangePasswordForm } from 'app/pages/ChangePassword';
import { useAsyncAction } from 'app/services';
import { sessionChangeOwnPassword, sessionSignOut } from 'app/store/session';
import { resolveApiErrorMessage } from 'app/utils/apiError';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link as RouterLink, Redirect } from 'react-router-dom';
const FALLBACK_ERROR = 'Не удалось изменить пароль. Попробуйте снова или обратитесь в техническую поддержку.';
const ChangePassword = () => {
    const formRef = useRef(null);
    const { session } = useSelector((state) => state.session);
    const { asyncAction: submit, isLoading, isError, error } = useAsyncAction(sessionChangeOwnPassword);
    const { asyncAction: signOut } = useAsyncAction(sessionSignOut);
    const handleClickForm = () => {
        var _a;
        if (isLoading)
            return;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.handleSubmitForm();
    };
    const handleSubmitForm = (params) => {
        if (isLoading)
            return;
        submit(params.password);
    };
    const handleSignOut = () => {
        signOut();
    };
    const handleLogKey = (e) => {
        if (e.code === 'Enter' || e.code === 'NumpadEnter') {
            e.preventDefault();
            handleClickForm();
        }
    };
    useEffect(() => {
        document.addEventListener('keydown', handleLogKey);
        return () => {
            document.removeEventListener('keydown', handleLogKey);
        };
    }, []);
    // Экран доступен только залогиненному пользователю; после смены пароля
    // флаг снимается, и роутер отправляет пользователя в обычное приложение.
    if (!session) {
        return React.createElement(Redirect, { to: '/' });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { direction: 'row', flexDirection: 'column', sx: (theme) => ({
                paddingBottom: theme.spacing(2),
                '.MuiTypography-h5': {
                    marginBottom: theme.spacing(1),
                },
                '.MuiTypography-body2': {
                    color: theme.palette.text.secondary,
                },
            }) },
            React.createElement(Typography, { variant: 'h5' }, "\u0421\u043C\u0435\u043D\u0430 \u043F\u0430\u0440\u043E\u043B\u044F"),
            React.createElement(Typography, { variant: 'body2' }, "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440 \u043E\u0431\u044F\u0437\u0430\u043B \u0441\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C. \u041F\u0440\u0438\u0434\u0443\u043C\u0430\u0439\u0442\u0435 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C \u2014 \u0434\u0440\u0443\u0433\u0438\u0435 \u0440\u0430\u0437\u0434\u0435\u043B\u044B \u043E\u0442\u043A\u0440\u043E\u044E\u0442\u0441\u044F \u0441\u0440\u0430\u0437\u0443 \u043F\u043E\u0441\u043B\u0435 \u0441\u043C\u0435\u043D\u044B.")),
        React.createElement(ChangePasswordForm, { ref: formRef, onSubmit: handleSubmitForm }),
        React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'flex-start', spacing: 2, sx: (theme) => ({
                marginTop: theme.spacing(3),
                width: '100%',
                '.MuiLoadingButton-root': {
                    lineHeight: '22px',
                    padding: theme.spacing(2),
                },
                '.MuiAlert-root': {
                    width: '100%',
                    borderRadius: theme.shape.borderRadius,
                },
            }) },
            isError && React.createElement(Alert, { severity: 'error' }, resolveApiErrorMessage(error, FALLBACK_ERROR)),
            React.createElement(LoadingButton, { variant: 'contained', loading: isLoading, onClick: handleClickForm, fullWidth: true, disableElevation: true }, "\u0421\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C"),
            React.createElement(Typography, { variant: 'body2' },
                React.createElement(Link, { to: '#', variant: 'subtitle2', underline: 'none', onClick: handleSignOut, component: RouterLink }, "\u0412\u044B\u0439\u0442\u0438 \u0438\u0437 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430")))));
};
export default ChangePassword;
